import { render, staticRenderFns } from "./StrongText.vue?vue&type=template&id=5f8cd3d4&scoped=true&"
import script from "./StrongText.vue?vue&type=script&lang=js&"
export * from "./StrongText.vue?vue&type=script&lang=js&"
import style0 from "./StrongText.vue?vue&type=style&index=0&id=5f8cd3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cd3d4",
  null
  
)

export default component.exports